import React from "react";
import { AppLogo } from "../../app-logo";
import { NavbarSearch } from "../navbar-search";
import "./top-bar.m.css";

const TopBar = () => {
  /** temporarilly hiding the top bar */
  let noShow=false;
  if(!noShow){
    return null;
  }
  return (
    <div styleName="container">
    <div styleName="main-wrapper" className="wider">
        <div styleName="logo-dropdown">
          <AppLogo />
        </div>
          <div styleName="react-audio-player">

          </div>
          <div>
            <NavbarSearch />
          </div>
          </div>
    </div>
  );
};

export { TopBar };
